import React from "react";
import { EditableSynonymGroup, SynonymUpdateInfo } from "../../types";

/** 仮想フォルダーコンテキスト型 */
export type VirtualFolderContextData = {
  path?: string;
  virtualFolderConfigId?: number;
  excludes?: string[];
  // 検索キーワード（参照・編集用データ）
  editableSearchKeywords: EditableSynonymGroup[];
  // 同義語
  synonym: {
    // 更新状態
    //  - ready: 未更新
    //  - waiting: 更新待ち
    //  - doing: 実行中(API応答待ち)
    //  - done: 完了
    updateStatus: "ready" | "waiting" | "doing" | "done";
    lastUpdateInfo?: SynonymUpdateInfo;
  };
  // 検索条件ドロワー開閉状態
  openSearchConditionDrawer: boolean;
};

/** 仮想フォルダーコンテキスト初期値 */
export const virtualFolderContextInitData: VirtualFolderContextData = {
  editableSearchKeywords: [],
  synonym: {
    updateStatus: "ready",
  },
  openSearchConditionDrawer: true,
};

/** 仮想フォルダーアクションタイプ列挙型 */
export enum VirtualFolderActionType {
  CLEAR = "CLEAR",
  UPDATE = "UPDATE",
}

/** 仮想フォルダーアクション型 */
export interface VirtualFolderAction {
  type: VirtualFolderActionType;
  payload?: VirtualFolderContextData;
}

/** 仮想フォルダーリデューサー */
export const VirtualFolderReducer: React.Reducer<
  VirtualFolderContextData,
  VirtualFolderAction
> = (state: VirtualFolderContextData, action: VirtualFolderAction) => {
  switch (action.type) {
    case VirtualFolderActionType.CLEAR:
      return virtualFolderContextInitData;
    case VirtualFolderActionType.UPDATE:
      return {
        ...state,
        ...action.payload,
      };
    default:
      throw Error();
  }
};

/** 仮想フォルダーコンテキスト */
export const virtualFolderContextData = React.createContext<
  VirtualFolderContextData
>(virtualFolderContextInitData);

/** 仮想フォルダーディスパッチャ */
export const VirtualFolderDispatchContext = React.createContext<
  React.Dispatch<VirtualFolderAction> | undefined
>(undefined);
